exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".educations-header {\n  font-size: 40px;\n  line-height: 1.1;\n  font-family: \"Google Sans Regular\";\n  text-align: center;\n}\n\n@media (max-width: 1380px) {\n  .educations-header {\n    font-size: 35px;\n  }\n}\n\n@media (max-width: 768px) {\n  .educations-header {\n    font-size: 30px;\n  }\n}\n", ""]);

